<div class="summary p-0">
    <div *ngIf="totalPasajeros && totalPasajeros.paxes && totalPasajeros.paxes.length > 0 && totalPasajeros.total > totalPasajeros.paxes.length" class="col-12 p-3 mb-3 d-flex"
    [ngStyle]="{'background-color':styleSidebar?.background_color,
                'color': styleSidebar?.color}"
                style="gap: 1em;">
                          <button
          id="buttonSync"
          class="btn btn-i btn-actualizar d-flex justify-content-center align-items-center rounded w-100"
          style="gap: .2em;"
          [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1, 'color': buttonTextActive}"
          (click)="addForm('adult')"
          type="button"
          name="btn-update"
          tooltip="Agregar un formulario para adulto"
          placement="bottom"
            >
            <img #icon style=" width: 16px" src="../../../assets/img/app/little-icons/user.svg" class="ml-2"  alt="">

            <p class="mb-0" [ngStyle]="{'color': styleSidebar?.color }" >Agregar adulto</p>
            </button>
          <button
          id="buttonSync"
          class="btn btn-i btn-actualizar d-flex justify-content-center align-items-center rounded w-100"
          style="gap: .2em;"
          [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1, 'color': buttonTextActive}"
          (click)="addForm('children')"
          type="button"
          name="btn-update"
          tooltip="Agregar un formulario para niño"
          placement="bottom"
          >
          <span class="icon icon-child"></span>

          <p class="mb-0" [ngStyle]="{'color': styleSidebar?.color }" >Agregar niño</p>
          </button>
    </div>
  <div *ngFor="let item of itineraryItems; let i = index" class="row ml-0 mr-0 mb-4">
    <ng-container>
      <div class="col-12 head-destiny p-3 mb-3 d-flex flex-column" *ngIf="!verifyCityExist(i)"
            [ngStyle]="{'background-color':styleSidebar?.background_color,
                        'color': styleSidebar?.color}">
        <span class="title-city mb-2">{{item.destination.iata_code}} <span *ngIf="item.categoryName !== 'INSURANCE'">- {{item.cityame}}</span></span>
      </div>

    </ng-container>

    <div class="col-2 p-0 d-flex flex-column align-items-center">

      <span class="circle p-0" [ngClass]="{
        'background-icon-status-saved' : item.status_id === 1,
        'background-icon-status-reserved': item.status_id === 2,
        'background-icon-status-locked': item.status_id === 3,
        'background-icon-status-denied': item.status_id === 4,
        'background-icon-status-cancelled': item.status_id === 5,
        'background-icon-status-paid-agency': item.status_id === 6,
        'background-icon-status-paid-provider': item.status_id === 7,
        'background-icon-status-billed': item.status_id === 8,
        'background-icon-status-pending-approve-pay': item.status_id === 9,
        'background-icon-status-completed': item.status_id === 10
      }">
       <img  width="25px"
             src="../../../assets/icons/itinerary/bed-svgrepo-com.svg"
            *ngIf="item.categoryName=='HOTELS'">

        <svg *ngIf="item.categoryName == 'RENT-A-CAR'" [ngClass]="{
          'icon-status-saved' : item.status_id === 1,
          'icon-status-reserved': item.status_id === 2,
          'icon-status-locked': item.status_id === 3,
          'icon-status-denied': item.status_id === 4,
          'icon-status-cancelled': item.status_id === 5,
          'icon-status-paid-agency': item.status_id === 6,
          'icon-status-paid-provider': item.status_id === 7,
          'icon-status-billed': item.status_id === 8,
          'icon-status-pending-approve-pay': item.status_id === 9,
          'icon-status-completed': item.status_id === 10
        }" class="icon-svg" x="0px" y="0px" viewBox="0 0 447.64499 370.905">
          <g id="g32" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g34" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g36" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g38" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g40" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g42" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g44" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g46" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g48" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g50" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g52" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g54" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g56" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g58" transform="translate(-14.821571,-74.886488)">
          </g>
          <g id="g60" transform="translate(-14.821571,-74.886488)">
          </g>
          <path
            d="m 447.639,206.032 c 0,-8.805 -1.988,-17.215 -5.578,-24.909 -0.37,-1.956 -0.793,-3.909 -1.322,-5.89 l -38.884,-96.364998 -0.263,-0.867 C 387.987,37.492002 368.629,0 319.543,0 H 131.868 C 81.572,0 63.799,38.421002 49.896,77.776002 L 9.223,174.376 C 3.343,183.797 0,194.574 0,206.032 v 29.986 c 0,4.636 0.548,9.171 1.59,13.539 C 0.577,252.196 0,255.04 0,258.038 v 89.185 c 0,13.078 10.602,23.68199 23.68,23.68199 h 49.14 c 13.070999,0 23.672999,-10.60399 23.672999,-23.68199 V 302.624 H 353.953 v 44.599 c 0,13.078 10.604,23.68199 23.683,23.68199 h 46.326 c 13.083,0 23.683,-10.60399 23.683,-23.68199 v -89.195 c 0,-2.987 -0.583,-5.844 -1.588,-8.474 1.038,-4.375 1.588,-8.905 1.588,-13.54 v -29.981 h -0.01 z M 78.754,87.451002 c 15.482999,-43.683 27.934,-57.018 53.114,-57.018 h 187.664 c 24.995,0 38.913,14.873 53.056,56.83 L 400.963,144.765 c -9.265,-3.431 -19.461,-5.335 -30.173,-5.335 H 76.849 c -9.645,0 -18.862,1.551 -27.366,4.358 z M 103.129,247.406 H 51.281 c -9.335,0 -16.906,-7.578 -16.906,-16.912 0,-9.337 7.571,-16.91 16.906,-16.91 h 51.848 c 9.339,0 16.91,7.573 16.91,16.91 0,9.334 -7.576,16.912 -16.91,16.912 z m 183.155,-3.387 h -120.6 c -5.913,0 -10.704,-4.794 -10.704,-10.704 0,-5.921 4.791,-10.713 10.704,-10.713 h 120.6 c 5.92,0 10.71,4.792 10.71,10.713 0,5.91 -4.79,10.704 -10.71,10.704 z m 108.767,3.387 h -51.846 c -9.343,0 -16.91,-7.578 -16.91,-16.912 0,-9.337 7.573,-16.91 16.91,-16.91 h 51.846 c 9.343,0 16.916,7.573 16.916,16.91 0,9.334 -7.573,16.912 -16.916,16.912 z"
            id="svg_2" inkscape:connector-curvature="0" />
        </svg>
        <img  width="25px"
              src="../../../assets/icons/itinerary/school_15476203.svg"
             *ngIf="item.categoryName == 'TRANSPORTS'">
        <img
              *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 6"
              width="25px"
              src="../../../assets/img/app/categories-search-box/road-map.svg"
              alt=""
        />
        <img
              *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 9"
              width="25px"
              src="../../../assets/img/app/categories-search-box/combi-ticket.svg"
              alt=""
        />
        <img
            *ngIf="item.categoryName=='INSURANCE'"
            width="25px"
            src="../../../assets/img/app/categories-search-box/icon-seguro.svg"
        />
        <i *ngIf="item.categoryName=='PTHEMES'" class="icon-small icon-pthemes iconstart text-center pl-1"></i>
        <i *ngIf="item.categoryName=='DISNEY'" class="icon-small icon-disney iconstart text-center"></i>

        <i *ngIf="item.categoryName=='CRUISES'" class="icon-small icon-crucero iconstart text-center"></i>
      </span>


    </div>

    <div class="col-10">
      <div class="row">
        <div class="col-12">
          <p class="item  mt-0" *ngIf="item.categoryName!='DISNEY'"  [ngStyle]="{'color': styleSidebar?.color}" style="font-size: 14px;">
            {{item.title}} </p>
          <span class="item col-8  mt-0"  [ngStyle]="{'color': styleSidebar?.color}" *ngIf="item.categoryName=='DISNEY'">{{item.hotel.title}}</span>
          <p  *ngIf="item.categoryName !== 'INSURANCE'" class="m-0 location-name dark-1 " [ngStyle]="{'color': styleSidebar?.color}">
            <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px" height="15px"></object>
            {{item.cityame}}
          </p>
          <p  *ngIf="item.categoryName === 'INSURANCE'" class="m-0 location-name dark-1 " [ngStyle]="{'color': styleSidebar?.color}">
            <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px" height="15px"></object>
             {{item.form.begin}} > {{item.form?.destination?.name || item.form.destination}}
          </p>
        </div>
      </div>
      <div class="col-12 p-0">
        <hr class="mt-1 mb-1" [ngStyle]="{'border-top': '1px dotted '+ styleSidebar?.color}" >
        <div class="mt-3 d-flex justify-content-between align-items-center">
          <div class="d-flex flex-row align-items-center mt-1">
            <span class=" nights d-flex align-items-center"  [ngStyle]="{'color': styleSidebar?.color}" *ngIf="item.categoryName=='HOTELS'">
              <object type="image/svg+xml" #icon style=" width: 16px" data='/assets/img/app/little-icons/bed-gray.svg'
                class=" mr-1"></object>
              {{item.stay?.nights}} NOCHES
            </span>

          </div>
          <div class="adjust-product-status-saved">
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-saved"
              *ngIf="item.status_id == 1">{{item.status}}</span>
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-reserved"
              *ngIf="item.status_id == 2">{{item.status}}</span>
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-locked"
              *ngIf="item.status_id == 3">{{item.status}}</span>
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-denied"
              *ngIf="item.status_id == 4">{{item.status}}</span>
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-cancelled"
              *ngIf="item.status_id == 5">{{item.status}}</span>
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-paid-agency"
              *ngIf="item.status_id == 6">{{item.status}}</span>
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-paid-provider"
              *ngIf="item.status_id == 7">{{item.status}}</span>
            <span class="status-item badge d-flex justify-content-center align-items-center product-status-paid-completed"
              *ngIf="item.status_id == 8">{{item.status}}</span>
          </div>
        </div>

        <!-- DESCRIPCIÓN -->

        <div class="mt-3" *ngIf="item.categoryName=='HOTELS'" >
          <p class="m-0 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"> <strong>Tipo: </strong><span>{{item.room?.roomType}}</span></p>
        </div>
        <div class="mt-3" *ngIf="item.categoryName=='TRANSPORTS'" >
          <p *ngIf="item?.firstWay" class="m-0 mb-1 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong>{{getTypeWay(item?.firstWay)}}</strong></p>
          <p class="m-0 mb-1 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong>Tipo traslado: </strong><span>{{item.transferType}}</span></p>
          <p class="m-0 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong>Tipo vehículo: </strong><span>{{item.vehicle.type}}</span></p>
        </div>

        <div class="mt-3" *ngIf="item.categoryName=='RENT-A-CAR'" >
          <p class="m-0 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"> <strong>Tipo: </strong><span>{{item.type}} - {{item.type_definition}}</span></p>
        </div>


        <div class="mt-3" *ngIf="item.categoryName=='TOURS'">
          <ng-container *ngIf="item?.experience">
            <p *ngIf="item.productName" class="m-0 mb-1 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong></strong><span>{{item.productName}}</span></p>
            <p *ngIf="item.experience?.sessions" class="m-0 mb-1 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong>Inicio: </strong><span>{{item.experience?.sessions}} hs.</span></p>
            <p *ngIf="item.experience?.language" class="m-0 mb-1 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong>Idioma: </strong><span>{{item.experience?.language}}</span></p>
            <p  *ngIf="getDurationTour(item) !== ''" class="m-0 mb-1 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong>Duración tour: </strong><span>{{getDurationTour(item)}}</span></p>
          </ng-container>
        </div>

        <div class="mt-3" *ngIf="item.categoryName=='INSURANCE'">
          <p class="m-0 mb-0 typeRoom "  [ngStyle]="{'color': styleSidebar?.color}"><strong>Tipo de viaje: </strong><span>{{item.trip?.tripType}}</span></p>
        </div>

        <!-- IN - OUT -->

        <div class="d-flex flex-row mt-2" *ngIf="item.categoryName=='HOTELS'">
          <p class="hotel-date m-0 "  [ngStyle]="{'color': styleSidebar?.color}"><strong>IN:</strong>
            {{ item.arrivalDate | date:'mediumDate'}}</p>
          <P class="hotel-date m-0 ml-1 adjust-date-out"  [ngStyle]="{'color': styleSidebar?.color}"><strong>OUT:</strong>
            {{ item.departureDate | date:'mediumDate'}}</P>
        </div>

        <div class="d-flex flex-column mt-2" *ngIf="item.categoryName=='HOTELS'">
          <p class="hotel-date m-0 "  [ngStyle]="{'color': styleSidebar?.color}"><strong>Check In:</strong>
            {{ item.checkTimes.checkIn}}</p>
          <P class="hotel-date m-0 adjust-date-out"  [ngStyle]="{'color': styleSidebar?.color}"><strong>Check Out:</strong>
            {{ item.checkTimes.checkOut}}</P>
        </div>

        <div class="d-flex flex-row mt-2" *ngIf="item.categoryName=='RENT-A-CAR'">
          <p class="hotel-date m-0 "  [ngStyle]="{'color': styleSidebar?.color}"><strong>IN:</strong>
            {{ item.arrivalDate | date:'mediumDate'}}</p>
          <P class="hotel-date m-0 ml-1 adjust-date-out"  [ngStyle]="{'color': styleSidebar?.color}"><strong>OUT:</strong>
            {{ item.departureDate | date:'mediumDate'}}</P>
        </div>

        <div class="d-flex flex-row mt-2" *ngIf="item.categoryName=='TOURS'">
          <p class="hotel-date m-0 "  [ngStyle]="{'color': styleSidebar?.color}"><strong>IN:</strong>
            {{ item.arrivalDate | date:'mediumDate'}}</p>
          <P class="hotel-date m-0 ml-1 adjust-date-out"  [ngStyle]="{'color': styleSidebar?.color}"><strong>OUT:</strong>
            {{ item.departureDate | date:'mediumDate'}}</P>
        </div>

        <div class="d-flex flex-row mt-2" *ngIf="item.categoryName=='INSURANCE'">
          <p class="hotel-date m-0 "  [ngStyle]="{'color': styleSidebar?.color}"><strong>IN:</strong>
            {{ item.arrivalDate | date:'mediumDate'}}</p>
          <P class="hotel-date m-0 ml-1 adjust-date-out"  [ngStyle]="{'color': styleSidebar?.color}"><strong>OUT:</strong>
            {{ item.departureDate | date:'mediumDate'}}</P>
        </div>



      <!-- POLITICAS DE CANCELACIÓN -->

        <div class="mt-2" *ngIf="item.categoryName=='HOTELS'" >
          <div class="d-flex align-items-center">
            <p *ngIf="item.rateClassId === 'R'" class="m-0 typeRoom" style="color: #00d196"><strong>REEMBOLSABLE </strong></p>
            <div class="info-tool d-flex flex-column" *ngIf="item.rateClassId === 'R'">
             <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                   <span class="tooltip-info shadow-md">
                                       <table>
                                         <tr>
                                           <th style="text-align: center">
                                             <p >Hasta</p>
                                           </th>
                                          <th style="text-align: center">
                                             <p>Tarifa</p>
                                           </th>
                                         </tr>
                                         <ng-container *ngFor="let cancellation of item?.room?.cancellationPolicy">
                                           <tr>
                                             <td style="text-align: start">
                                               <p class="mb-2">{{ cancellation.from | date: 'dd/MM/yyyy' }}</p>
                                             </td>
                                             <td>
                                               <p class="mb-2">
                                                <!-- {{cancellation.currency}} {{ cancellation.amount | number: '1.2-2' }} -->
                                                 {{currencyAgency?.code}} {{ cancellation.amount
                                                                                              | currencyConverterPure:
                                                                                                cancellation.currency:
                                                                                                currencyAgency?.code:
                                                                                                currencies
                                                                                              | number: '1.2-2'}}
                                              </p>
                                             </td>
                                           </tr>
                                         </ng-container>
                                       </table>
                                     </span>
                                 </div>
          </div>
          <p *ngIf="item.rateClassId === 'NR'" class="m-0 typeRoom" style="color: #d60159"><strong>NO REEMBOLSABLE</strong></p>

        </div>

        <div class="mt-2 d-flex" *ngIf="item.categoryName=='RENT-A-CAR'" >
          <p *ngIf="item.rateClass === 'R'" class="m-0 typeRoom" style="color: #00d196"><strong>Reembolsable </strong></p>
          <p *ngIf="item.rateClass === 'NR'" class="m-0 typeRoom" style="color: #d60159"><strong>No Reembolsable </strong></p>
          <p *ngIf="item.rateClass === null" class="m-0 typeRoom"><strong>Cancelación no configurada</strong></p>
          <div class="info-tool d-flex flex-column" *ngIf="item?.rateClass === 'R'">
             <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                   <span class="tooltip-info shadow-md">
                                       <table>
                                         <tr>
                                           <th style="text-align: center">
                                             <p >Hasta</p>
                                           </th>
                                          <th style="text-align: center">
                                             <p>Tarifa</p>
                                           </th>
                                         </tr>
                                         <ng-container *ngFor="let cancellation of item?.cancellationPolicies">
                                           <tr>
                                             <td style="text-align: start">
                                               <p class="mb-2">{{ cancellation.from | date: 'dd/MM/yyyy' }}</p>
                                             </td>
                                             <td>
                                               <p class="mb-2">
                                                <!-- {{cancellation.currency}} {{ cancellation.amount | number: '1.2-2' }} -->
                                                                  {{currencyAgency?.code}} {{ cancellation.amount
                                                                                              | currencyConverterPure:
                                                                                                item.currency:
                                                                                                currencyAgency?.code:
                                                                                                currencies
                                                                                              | number: '1.2-2'}}
                                              </p>
                                             </td>
                                           </tr>
                                         </ng-container>
                                       </table>
                                     </span>
                                 </div>

        </div>

        <div class="mt-2 d-flex" *ngIf="item.categoryName=='TRANSPORTS'" >
          <p *ngIf="item.pricing.rateClass === 'R'" class="m-0 typeRoom" style="color: #00d196"><strong>Reembolsable </strong></p>
          <p *ngIf="item.pricing.rateClass === 'NR'" class="m-0 typeRoom" style="color: #d60159"><strong>No Reembolsable </strong></p>
          <p *ngIf="item.pricing.rateClass === null" class="m-0 typeRoom"><strong>Cancelación no configurada</strong></p>
          <div class="info-tool d-flex flex-column" *ngIf="item?.pricing?.rateClass === 'R'">
          <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                   <span class="tooltip-info shadow-md">
                                       <table>
                                         <tr>
                                           <th style="text-align: center">
                                             <p >Hasta</p>
                                           </th>
                                          <th style="text-align: center">
                                             <p>Tarifa</p>
                                           </th>
                                         </tr>
                                         <ng-container *ngFor="let cancellation of item?.cancellationPolicies">
                                           <tr>
                                             <td style="text-align: start">
                                               <p class="mb-2">{{ cancellation.from | date: 'dd/MM/yyyy' }}</p>
                                             </td>
                                             <td>
                                               <p class="mb-2">
                                                <!-- {{cancellation.currency}} {{ cancellation.amount | number: '1.2-2' }} -->
                                                                  {{currencyAgency?.code}} {{ cancellation.amount
                                                                                              | currencyConverterPure:
                                                                                                item.currency:
                                                                                                currencyAgency?.code:
                                                                                                currencies
                                                                                              | number: '1.2-2'}}
                                              </p>
                                             </td>
                                           </tr>
                                         </ng-container>
                                       </table>
                                     </span>
                                 </div>

        </div>
        <div class="mt-2 d-flex" *ngIf="item.categoryName=='TOURS'" >
          <p *ngIf="item.rateClassId === 'R'" class="m-0 typeRoom" style="color: #00d196"><strong>Reembolsable </strong></p>
          <p *ngIf="item.rateClassId === 'NR'" class="m-0 typeRoom" style="color: #d60159"><strong>No Reembolsable </strong></p>
          <p *ngIf="item.rateClassId === null" class="m-0 typeRoom"><strong>Cancelación no configurada</strong></p>
          <div class="info-tool d-flex flex-column" *ngIf="item?.rateClassId === 'R'">
             <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                   <span class="tooltip-info shadow-md">
                                       <table>
                                         <tr>
                                           <th style="text-align: center">
                                             <p >Hasta</p>
                                           </th>
                                          <th style="text-align: center">
                                             <p>Tarifa</p>
                                           </th>
                                         </tr>
                                         <ng-container *ngIf="item.subCategoryId === 6">
                                           <ng-container *ngFor="let cancellation of item?.experience?.cancellation_policy; let i = index;">
                                             <tr>
                                               <td style="text-align: start">
                                                 <p class="mb-2">{{ cancellation.dateFrom | date: 'dd/MM/yyyy' }}</p>
                                               </td>
                                               <td>
                                                 <p class="mb-2">
                                                 {{currencyAgency?.code}}
                                                 {{ item?.cancellationPolicies?.cancellationPolicies[i].amount
                                                    | currencyConverterPure:
                                                      item?.currency:
                                                      currencyAgency?.code:
                                                      currencies
                                                    | number: '1.2-2'}}
                                                </p>
                                               </td>
                                             </tr>
                                           </ng-container>
                                         </ng-container>
                                       </table>
                                     </span>
                                 </div>

        </div>
        <div class="mt-2 d-flex" *ngIf="item.categoryName=='INSURANCE'" >
          <p *ngIf="item.rateClass === 'R'" class="m-0 typeRoom" style="color: #00d196"><strong>Reembolsable </strong></p>
          <p *ngIf="item.rateClass === 'NR'" class="m-0 typeRoom" style="color: #d60159"><strong>No Reembolsable </strong></p>
          <p *ngIf="item.rateClass === null" class="m-0 typeRoom"><strong>Cancelación no configurada</strong></p>
          <div class="info-tool d-flex flex-column" *ngIf="item?.rateClass === 'R'">
             <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                   <span class="tooltip-info shadow-md">
                                       <table>
                                         <tr>
                                           <th style="text-align: center">
                                             <p >Hasta</p>
                                           </th>
                                          <th style="text-align: center">
                                             <p>Tarifa</p>
                                           </th>
                                         </tr>
                                         <ng-container *ngFor="let cancellation of item?.cancellationPolicies">
                                           <tr>
                                             <td style="text-align: start">
                                               <p class="mb-2">{{ cancellation.from | date: 'dd/MM/yyyy' }}</p>
                                             </td>
                                             <td>
                                               <p class="mb-2">
                                                <!-- {{cancellation.currency}} {{ cancellation.amount | number: '1.2-2' }} -->
                                                                  {{currencyAgency?.code}} {{ cancellation.amount
                                                                                              | currencyConverterPure:
                                                                                                item.currency:
                                                                                                currencyAgency?.code:
                                                                                                currencies
                                                                                              | number: '1.2-2'}}
                                              </p>
                                             </td>
                                           </tr>
                                         </ng-container>
                                       </table>
                                     </span>
                                 </div>

        </div>

        <div class="d-flex flex-column mt-2" *ngIf="item.categoryName == 'TRANSPORTS'">
          <p class="hotel-date m-0 mb-1" [ngStyle]="{'color': styleSidebar?.color}" style="line-height: 1 !important"><strong>Pick up:</strong> {{extractNameTransport(item.formTransport.firstOrigin, 'origin', item.payload[0])}}</p>
          <p class="hotel-date m-0 mb-2 "  [ngStyle]="{'color': styleSidebar?.color}" style="line-height: 1 !important"><strong>Drop off:</strong> {{extractNameTransport(item.formTransport.firstDestination, 'destination', item.payload[0])}}</p>
          <p class="hotel-date m-0 mb-1" [ngStyle]="{'color': styleSidebar?.color}" style="line-height: 1 !important"><strong>Punto de partida:</strong> {{item.payload[0].transfers.pickupLocation.address}}</p>
          <p class="hotel-date m-0 " [ngStyle]="{'color': styleSidebar?.color}" style="line-height: 1 !important"><strong>Punto de llegada:</strong> {{item.payload[0].transfers.dropoffLocation.address}}</p>
        </div>
        <div class="d-flex flex-column mt-2" *ngIf="item.categoryName == 'TRANSPORTS'">
          <p class="hotel-date m-0"  [ngStyle]="{'color': styleSidebar?.color}"><strong>Inicio:</strong> {{item.arrivalDate | date: 'dd MMM YY'}} ({{item.payload[0].transfers.pickupTime}} hs. - {{getMessageFirstTime(item.payload[0].transfers.pickupLocation, 'origin')}})</p>
        </div>
        <p class="hotel-room m-0 mt-2 "  [ngStyle]="{'color': styleSidebar?.color}" *ngIf="item.categoryName=='HOTELS' || item.categoryName=='TRANSPORTS' || item.categoryName=='TOURS'  || item.categoryName==='INSURANCE'">
          <span *ngIf="item.categoryName=='HOTELS'" [ngStyle]="{'color': styleSidebar?.color}">{{item.payloadUpdate?.products[0]?.others?.hotels?.roomConfiguration.length}} Hab.</span>
          <span *ngIf="item.categoryName=='TRANSPORTS'"><img #icons_lugagge src="../../../assets/icons/detalle-itinerary-resevation/bi-lugagge-fill.svg" style="margin-bottom: 10px;width: 21px;" alt="" > {{item.vehicle?.bag?.maxBag}} Max.</span>
          <span class="ml-2 pl-1">  <img #icon style="width: 16px;" src="../../../assets/img/app/little-icons/user.svg" alt=""> {{item.paxAdults}}</span>
          <span class="ml-2">  <img #icons_two style="width: 14px;" src="../../../assets/img/app/little-icons/children-2.svg" alt=""> {{item.paxChildren}} </span>
        </p>
      </div>
      <div class="col-12 p-0 mt-1">
         <span *ngIf="(item.netPriceAgent)" class="priceItem dark-1">
                                <div class="mb-1" *ngIf="item.currency !== currencyAgency?.code">
                                  <div class="d-flex justify-content-end align-items-center">
                                    <p class="mb-0"
                                    style="font-family: 'Rubik', serif; font-size: 14px; font-weight: 400;"
                                    [ngStyle]="{ color: styleSidebar?.color }"
                                    >{{item.currency}} {{(item.netPriceAgent + (item.categoryName === 'HOTELS' ? (item.room?.pricing?.taxesExcluded || 0) : 0)) | number:'1.2-2'}}</p>
                                                    <div class="info-tool d-flex flex-column position-relative">
                                     <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                                      <span class="tooltip-info shadow-md">
                                        <div class="d-flex justify-content-center align-items-center px-2 py-1">
                                          <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
          <div class="d-flex justify-content-end">
            <p class="mb-0" style="text-align: end;"
                [ngStyle]="{
                  'color': styleSidebar?.color,
                  'font-size':  item.netPriceAgent
                              | currencyConverterPure:
                                item.currency:
                                currencyAgency?.code:
                                currencies
                             | dynamicFontSize: 25 : fontSizeAdjustments
                }"
                >

                 {{currencyAgency?.code}} {{ (item.netPriceAgent + (item.categoryName === 'HOTELS' ? (item.room?.pricing?.taxesExcluded || 0) : 0))
                                      | currencyConverterPure:
                                        item.currency:
                                        currencyAgency?.code:
                                        currencies
                                      | number: '1.2-2'}}
              </p>
               <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="item.currency"
                                            [valueProduct]="item.netPriceAgent + (item.categoryName === 'HOTELS' ? (item.room?.pricing?.taxesExcluded || 0) : 0)"
                                            >
                </usb-tooltip-convert-amount>
          </div>
          <div class="d-flex justify-content-end">
            <p class="mb-0" style="font-family: 'Poppins', sans-serif; font-size: 12px; text-align: end;"  [ngStyle]="{'color': styleSidebar?.color}">Imp. incl.</p>

            <usb-tooltip-taxes-breakdown
              *ngIf="item.room?.pricing?.taxes && item.room?.pricing?.taxes.length > 0"
              [taxes]="item.room?.pricing?.taxes"
              [currency]="item?.currency"
              [clientsSettingAppBooking]="getClientsSettingAppBooking"
              [netTotal]="{
                amountConverted: (( (item.room?.pricing?.taxesExcluded + taxSum) > 0 ? item.netPriceBookingFreeTax : item.netPriceBooking) | currencyConverterPure: currencyItinerary: currencyAgency.code: currencies),
                agencyCurrency: currencyAgency?.code,
                amountOriginal: ((item.room?.pricing?.taxesExcluded + taxSum) > 0 ? item.netPriceBookingFreeTax : item.netPriceBooking),
                originalCurrency: item?.currency
              }"
              [dailyPrices]="item.room?.pricing.dailyPrices"
            ></usb-tooltip-taxes-breakdown>
          </div>

          </span>
      </div>
    </div>
  </div>
  <div class="col-12 p-3 mt-4" style="border-radius: 5px;background-color:#ffffff">
    <div class="row pl-2 pr-2 d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <span class="netPrice"  >
          TARIFA NETA
        </span>
      </div>
      <div class="d-flex">
        <div class="d-flex" *ngIf="taxSum > 0">
          <span
                [ngStyle]="{
                  'font-size': getNetTarifa() | dynamicFontSize: 25 : fontSizeAdjustments
                }"
            class="netPriceMount" >
            <!-- {{currencyItinerary}} {{ totalNetPriceBookingFreeTax | number:'1.2-2'}} -->
              {{currencyAgency?.code}} {{ getNetTarifa()
                                        | number: '1.2-2'}}
          </span>
            <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getNetTarifa()"
                                            >
                </usb-tooltip-convert-amount>
        </div>
        <div class="d-flex justify-content-end" *ngIf="taxSum === 0">
          <span
          class="netPriceMount"
              [ngStyle]="{
                'font-size': getTotalTarifa() | dynamicFontSize: 25 : fontSizeAdjustments
              }">
              <!-- {{currencyItinerary}} {{ price | number:'1.2-2'}} -->
                 {{currencyAgency?.code}} {{getTotalTarifa() | number: '1.2-2'}}
            </span>
                        <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalTarifa()"
                                            >
                </usb-tooltip-convert-amount>
        </div>
      </div>
    </div>
    <div *ngIf="taxSum > 0" class="row pl-2 pr-2 d-flex pt-2 justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <span class="netPrice" >
          CARGOS
        </span>
        <usb-tooltip-taxes-breakdown
          *ngIf="taxesSummable && taxesSummable.length > 0"
          class="ml-1"
          [taxes]="taxesSummable"
          [currency]="currencyAgency?.code"
          [clientsSettingAppBooking]="getClientsSettingAppBooking">
        </usb-tooltip-taxes-breakdown>
      </div>
      <div class="d-flex">
        <span  class="netPriceMount"
              [ngStyle]="{
                'font-size': taxSum | dynamicFontSize: 25 : fontSizeAdjustments
              }"
        >
            {{currencyAgency?.code}} {{taxSum | number: '1.2-2'}}
      </span>
      <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="taxSum"
                                            >
        </usb-tooltip-convert-amount>
      </div>
    </div>
    <div class="row pl-2 pr-2  pt-2 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <span class="netPrice">
          TARIFA TOTAL
        </span>
        <usb-tooltip-taxes-breakdown
          *ngIf="taxesNotSummable && taxesNotSummable.length > 0"
          class="ml-1"
          [taxes]="taxesNotSummable"
          [clientsSettingAppBooking]="getClientsSettingAppBooking">
        </usb-tooltip-taxes-breakdown>
      </div>
      <div class="d-flex">
        <span *ngIf="price" class="netPriceMount"
              [ngStyle]="{
                'font-size': getTotalTarifa() | dynamicFontSize: 25 : fontSizeAdjustments
              }"
        >
        <!-- {{currencyItinerary}} {{price | number:'1.2-2'}} -->
            {{currencyAgency?.code}} {{ getTotalTarifa() + (taxesExcluded || 0) | number: '1.2-2'}}
      </span>
                     <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalTarifa()"
                                            >
        </usb-tooltip-convert-amount>
      </div>
    </div>
  </div>

  <div class="col-12 p-3" style="margin-top: 5px; border-radius: 5px; background-color: #ffce0b;">
    <div class="row pl-2 pr-2 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center justify-content-start">

        <!-- <i class="icons-point mr-2"></i> -->
        <span class="font-blickoins">
          Total Blickoins
        </span>
      </div>
      <div class="d-flex align-items-center">
        <img src="../../../assets/img/app/little-icons/badge-bks.png" alt="" class="mr-1" style="filter: brightness(0);">
        <span *ngIf="blickoins" class="font-blickoins">{{ (blickoins ? blickoins : 0) | number:'1.2-2' }} BKS</span>
      </div>
    </div>
    <div class="row pl-2 pr-2 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center justify-content-start">

        <!-- <i class="icons-point mr-2"></i> -->
        <span class="font-blickoins">
          Creditos Blickoins
        </span>
      </div>
      <div class="d-flex align-items-center">
        <!-- <img src="../../../assets/img/app/little-icons/badge-bks.png" alt="" style="filter: brightness(0); margin-right: 22px;"> -->
        <span *ngIf="totalCreditBlickoins" class="font-blickoins">{{ (totalCreditBlickoins ? totalCreditBlickoins : 0) | number:'1.2-2' }} USD</span>
      </div>
    </div>
  </div>
</div>
